import { Component, HostListener, OnInit } from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';
import { NewLoginModalComponent } from '../new-login-modal/new-login-modal.component';
import { NewSignupModalComponent } from '../new-signup-modal/new-signup-modal.component';
@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.scss'],
})
export class NewHeaderComponent implements OnInit {
  menu:boolean = false;
  private modalRef;

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {}
  scroll: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 100) {
      this.scroll = true;
    } else {
      this.scroll = false;
    }
  }
  open_login_modal() {
    this.modalService.open(NewLoginModalComponent, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'v2_login_model',
    });
  }

  open_signup_modal() {
    this.modalService.open(NewSignupModalComponent, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'v2_login_model',
    });
  }
}

